import styles from "./SidesheetWarning.module.scss";
import { ReactComponent as OutlineWarningCircleRed } from "assets/svg/outline-warning-circle-red.svg";

interface SidesheetWarningProps {
  message: string;
}

const SidesheetWarning = ({ message }: SidesheetWarningProps) => (
  <div className={styles["warning"]}>
    <div className={styles["warning__icon"]}>
      <OutlineWarningCircleRed />
    </div>
    {message}
  </div>
);

export default SidesheetWarning;
